import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CredentialsFactory } from 'authorization';
import { map } from 'rxjs/operators';
import { RequestDataAccessServiceConfig } from '../request-data-access.service';
import { Injectable } from '@angular/core';
import { CouchDbRepository } from './couchdb-repository';

@Injectable()
export class CouchDbSequenceProvider {
  constructor(private config: RequestDataAccessServiceConfig, private http: HttpClient, private credentialsFactory: CredentialsFactory) {}

  public getSequenceValue(sequenceName: string): Observable<string> {
    const queryUrl = this.config.getServerURL() + 'sequences/' + sequenceName;
    return CouchDbRepository.authorizeExecute(this.credentialsFactory, (opt) =>
      this.http.get(queryUrl, opt).pipe(
        map((x: any) => {
          if (!!x._rev && !!x.value) {
            return x.value;
          }
          throw new Error('Sequence ' + sequenceName + ' not set');
        }),
      ),
    );
  }
}
